import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingOrderCancellationRequestImplEncoder } from "../../encoder/FixingOrderCancellationRequestImplEncoder";

import * as CubiqTS from "../../index";
import { FixingOrderCancellationRequest } from "../FixingOrderCancellationRequest";

export class FixingOrderCancellationRequestImpl
  extends ConcreteEncodable
  implements FixingOrderCancellationRequest
{
  public static enType: string = "com.bcdfx.model.event.FixingOrderCancellationRequestImpl";

  /*FID=1*/
  public orderIds: Array<string> | null = null;
  /*FID=2*/
  public reason: string;
  /*FID=4*/
  public tradingChannel: string;
  /*FID=5*/
  public oboUser: string;
  /*FID=6*/
  public ptpComposites: Array<CubiqTS.OrderPTPComposite> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingOrderCancellationRequestImplEncoder.Instance;
    this.setEncodableType(FixingOrderCancellationRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "FixingOrderCancellationRequestImpl[" +
      "orderIds=" +
      this.orderIds +
      "reason=" +
      this.reason +
      "tradingChannel=" +
      this.tradingChannel +
      "oboUser=" +
      this.oboUser +
      "ptpComposites=" +
      this.ptpComposites +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
